import React from 'react';
import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { WifiProfile } from '../../stores/TelematicsDevice/DeviceStateApi';

type PendingNetworksListProps = {
  profiles: WifiProfile[];
  onRemove: (index: number) => void;
};

export const PendingNetworksList: React.FC<PendingNetworksListProps> = ({ profiles, onRemove }) => {
  if (profiles.length === 0) {
    return null;
  }

  return (
    <>
      <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
        New networks
      </Typography>
      <List>
        {profiles.map((profile, index) => (
          <ListItem key={index} style={{ backgroundColor: '#e8f5e9' }}>
            <ListItemText
              primary={profile.ssid}
              secondary={`${profile.securityType || 'Automatic'}${
                profile.hiddenSsid ? ' (Hidden)' : ''
              }`}
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={() => onRemove(index)}>
                <Delete />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </>
  );
};
